<template>
  <div id="page-batch-weight-summary-list">
    <form autocomplete="off">
      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <vs-table stripe :data="[{}, {}]">
            <template slot="thead">
              <vs-th>Strain Name</vs-th>
              <vs-th>Flower/Bud W/Weight</vs-th>
              <vs-th>Shake/Trim W/Weight</vs-th>
              <vs-th>Waste W/Weight</vs-th>
              <vs-th>Flower/Bud D/Weight</vs-th>
              <vs-th>Shake/Trim D/Weight</vs-th>
              <vs-th>Waste D/Weight</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template>
              <vs-tr>
                <vs-td>-</vs-td>
                <vs-td><vs-input type="number" disabled :value="batch_weight_summary.fbwweight | weightFilter" icon-pack="feather" class="w-full mb-1" /></vs-td>
                <vs-td><vs-input type="number" disabled :value="batch_weight_summary.stwweight | weightFilter" icon-pack="feather" class="w-full mb-1" /></vs-td>
                <vs-td><vs-input type="number" disabled :value="batch_weight_summary.wastewweight | weightFilter" icon-pack="feather" class="w-full mb-1" /></vs-td>
                <vs-td><vs-input type="number" disabled :value="batch_weight_summary.fbdweight | weightFilter" icon-pack="feather" class="w-full mb-1" /></vs-td>
                <vs-td><vs-input type="number" disabled :value="batch_weight_summary.stdweight | weightFilter" icon-pack="feather" class="w-full mb-1" /></vs-td>
                <vs-td><vs-input type="number" disabled :value="batch_weight_summary.wastedweight | weightFilter" icon-pack="feather" class="w-full mb-1" /></vs-td>
                <vs-td>
                  <div v-if="checkPermissionByIds([permissions.BATCH_PLANT_EDIT])">
                    <vx-tooltip text="Edit Batch Weight Summary" v-if="!isEditMode">
                      <vs-button class="mr-1" type="filled" color="primary" icon="icon-edit" icon-pack="feather" @click="isEditMode = true" />
                    </vx-tooltip>
                    <div v-else class="flex">
                      <vx-tooltip text="Save Changes">
                        <vs-button class="mr-1" type="filled" color="primary" icon="icon-save" icon-pack="feather" @click="save_changes" :disabled="!validateForm || processing" />
                      </vx-tooltip>
                      <vx-tooltip text="Cancel">
                        <vs-button class="mr-1" color="danger" type="filled" icon="icon-x-circle" icon-pack="feather" @click="isEditMode = false" />
                      </vx-tooltip>
                    </div>
                  </div>
                  <div v-else>-</div>
                </vs-td>
              </vs-tr>
              <vs-tr v-if="isEditMode">
                <vs-td>
                  <select-2
                    autocomplete
                    :value="form.strain_name"
                    @input="(item) => (form.strain_name = item && item.value)"
                    name="Strain Name"
                    placeholder="Select Strain Name"
                    :options="batchStrains"
                    v-validate="'required'"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('Strain Name')">{{ errors.first('Strain Name') }}</span>
                </vs-td>
                <vs-td>
                  <vs-input type="number" v-model="form.fbwweight" @change="(i) => (form.fbwweight = parseFloat(i.target.value).toFixed(3))" step="0.001" icon-pack="feather" class="w-full mb-1" />
                </vs-td>
                <vs-td>
                  <vs-input type="number" v-model="form.stwweight" @change="(i) => (form.stwweight = parseFloat(i.target.value).toFixed(3))" step="0.01" icon-pack="feather" class="w-full mb-1" />
                </vs-td>
                <vs-td>
                  <vs-input
                    type="number"
                    v-model="form.wastewweight"
                    @change="(i) => (form.wastewweight = parseFloat(i.target.value).toFixed(3))"
                    step="0.01"
                    icon-pack="feather"
                    class="w-full mb-1"
                  />
                </vs-td>
                <vs-td>
                  <vs-input type="number" v-model="form.fbdweight" @change="(i) => (form.fbdweight = parseFloat(i.target.value).toFixed(3))" step="0.01" icon-pack="feather" class="w-full mb-1" />
                </vs-td>
                <vs-td>
                  <vs-input type="number" v-model="form.stdweight" @change="(i) => (form.stdweight = parseFloat(i.target.value).toFixed(3))" step="0.01" icon-pack="feather" class="w-full mb-1" />
                </vs-td>
                <vs-td>
                  <vs-input
                    type="number"
                    v-model="form.wastedweight"
                    @change="(i) => (form.wastedweight = parseFloat(i.target.value).toFixed(3))"
                    step="0.01"
                    icon-pack="feather"
                    class="w-full mb-1"
                  />
                </vs-td>
                <vs-td> - </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </form>
    <hr />
    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <vs-table
          id="table-loading"
          class="vs-con-loading__container"
          stripe
          :sst="true"
          maxHeight="500px"
          @search="updateSearchQuery"
          @change-page="handleChangePage"
          @sort="handleSort"
          :total="FilteredCount"
          pagination
          :max-items="length"
          search
          :data="logs"
        >
          <template slot="header">
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
              <!-- ITEMS PER PAGE -->
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ FilteredCount }} (filtered from {{ total }} total entries)
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(total)">
                      <span>All({{ total }})</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>

              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    Action
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item class="contents" @click="exportExcel">
                      <span>Export Excel</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown> -->
                <vs-row vs-justify="flex-end">
                  <vx-tooltip text="Export Excel">
                    <vs-button class="mr-1" type="filled" color="primary" icon-pack="feather" icon="icon-download" @click="exportExcel" />
                  </vx-tooltip>
                </vs-row>
              </div>
            </div>
          </template>

          <template slot="thead">
            <vs-th>Strain Name</vs-th>
            <vs-th>Flower/Bud W/Weight</vs-th>
            <vs-th>Shake/Trim W/Weight</vs-th>
            <vs-th>Waste W/Weight</vs-th>
            <vs-th>Flower/Bud D/Weight</vs-th>
            <vs-th>Shake/Trim D/Weight</vs-th>
            <vs-th>Waste D/Weight</vs-th>
            <vs-th>User</vs-th>
            <vs-th>Date</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }" ref="tableBody">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ tr.strain_name }}
              </vs-td>
              <vs-td>
                {{ tr.fbwweight }}
              </vs-td>
              <vs-td>
                {{ tr.stwweight }}
              </vs-td>
              <vs-td>
                {{ tr.wastewweight }}
              </vs-td>
              <vs-td>
                {{ tr.fbdweight }}
              </vs-td>
              <vs-td>
                {{ tr.stdweight }}
              </vs-td>
              <vs-td>
                {{ tr.wastedweight }}
              </vs-td>
              <vs-td>
                {{ tr.user && tr.user.username }}
              </vs-td>
              <vs-td>
                {{ formatDateTime(tr.created_at) }}
              </vs-td>
              <vs-td :data="tr.id">
                <div class="inline-flex">
                  <vx-tooltip v-if="checkPermissionByIds([permissions.BATCH_PLANT_DELETE]) && validToDelete(tr.created_at)" text="Delete Batch Weight Summary">
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5  hover:text-danger cursor-pointer" @click="deleteRecord(tr.id)" />
                  </vx-tooltip>
                  <div v-else>-</div>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import XLSX from 'xlsx'
import { weightMixins } from '@/utils/weightType'
import { dateMixins } from '@/mixins/dateMixins.js'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  components: {
    Select2
  },
  data: () => ({
    isEditMode: false,
    order: [],
    length: 10,
    page: 1,
    search: '',
    processing: false,
    batch_weight_summary: {
      fbwweight: 0,
      stwweight: 0,
      wastewweight: 0,
      fbdweight: 0,
      stdweight: 0,
      wastedweight: 0
    },
    form: {
      strain_name: '',
      fbwweight: 0,
      stwweight: 0,
      wastewweight: 0,
      fbdweight: 0,
      stdweight: 0,
      wastedweight: 0
    },
    batchStrains: []
  }),

  mixins: [weightMixins, dateMixins],

  computed: {
    ...mapState('batch', {
      logs: 'batchWeightSummaryLogs',
      loading: 'batchWeightSummary-loading',
      total: 'batchWeightSummary-total',
      FilteredCount: 'batchWeightSummary-FilteredCount',
      batchWeightSummary: 'batchWeightSummary'
    }),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds']),
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    ...mapActions('batch', ['getBatchWeightSummaryLogs', 'getBatchWeightSummary', 'updateBatchWeightSummary', 'getStrainList', 'deleteBatchWeighSummaryLogAsync']),

    validToDelete(createAt) {
      return moment().subtract(30, 'days') <= moment(createAt)
    },
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteBatchWeighSummaryLog(id),
        acceptText: 'Delete'
      })
    },
    deleteBatchWeighSummaryLog(id) {
      this.deleteBatchWeighSummaryLogAsync(id)
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Batch Summary Log deleted successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.getData()
          this.fetchBatchWeightSummary()
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    exportExcel() {
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(
        this.logs.map((plant) => ({
          'Strain Name': plant.strain_name,
          'Flower/Bud W/Weight': plant.fbwweight,
          'Shake/Trim W/Weight': plant.stwweight,
          'Waste W/Weight': plant.wastewweight,
          'Flower/Bud D/Weight': plant.fbdweight,
          'Shake/Trim D/Weight': plant.stdweight,
          'Waste D/Weight': plant.wastedweight,
          User: plant.user ? plant.user.username : '',
          Date: dateMixins.methods.formatDateTime(plant.created_at)
        }))
      )
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
      XLSX.writeFile(wb, 'Plant List.xlsx')
    },
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },
    handleChangePage(page) {
      this.page = page
      this.getData()
    },
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },
    getData() {
      const { page, length, order, search } = this
      this.getBatchWeightSummaryLogs({
        id: this.$route.params.id,
        data: {
          page,
          limit: length,
          order,
          search
        }
      })
        .then(() => {})
        .catch(() => {})
    },
    sendToEditPage(id) {
      this.$router.push(`/batches/${this.$route.params.id}/plants/${id}/edit`)
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please select strain name',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
      if (!(this.form.fbwweight || this.form.stwweight || this.form.wastewweight || this.form.fbdweight || this.form.stdweight || this.form.wastedweight)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Enter At-least One of the Weight',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
      try {
        this.processing = true

        const { message } = await this.updateBatchWeightSummary({
          id: this.$route.params.id,
          data: {
            strain_name: this.form.strain_name,
            fbwweight: this.form.fbwweight ? parseFloat(this.form.fbwweight) : 0,
            stwweight: this.form.stwweight ? parseFloat(this.form.stwweight) : 0,
            wastewweight: this.form.wastewweight ? parseFloat(this.form.wastewweight) : 0,
            fbdweight: this.form.fbdweight ? parseFloat(this.form.fbdweight) : 0,
            stdweight: this.form.stdweight ? parseFloat(this.form.stdweight) : 0,
            wastedweight: this.form.wastedweight ? parseFloat(this.form.wastedweight) : 0
          }
        })

        this.processing = false

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.fetchBatchWeightSummary()
        // delete this.form.strain_name
        // this.errors.clear()
        this.form.strain_name = ''
        this.form.fbwweight = 0
        this.form.stwweight = 0
        this.form.wastewweight = 0
        this.form.fbdweight = 0
        this.form.stdweight = 0
        this.form.wastedweight = 0

        await this.getData()
        this.isEditMode = false
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async fetchBatchWeightSummary() {
      try {
        const {
          data: { batch_weight_summary }
        } = await this.getBatchWeightSummary(this.$route.params.id)
        this.batch_weight_summary.fbwweight = batch_weight_summary ? batch_weight_summary.fbwweight : 0
        this.batch_weight_summary.stwweight = batch_weight_summary ? batch_weight_summary.stwweight : 0
        this.batch_weight_summary.wastewweight = batch_weight_summary ? batch_weight_summary.wastewweight : 0
        this.batch_weight_summary.fbdweight = batch_weight_summary ? batch_weight_summary.fbdweight : 0
        this.batch_weight_summary.stdweight = batch_weight_summary ? batch_weight_summary.stdweight : 0
        this.batch_weight_summary.wastedweight = batch_weight_summary ? batch_weight_summary.wastedweight : 0
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  async mounted() {
    this.fetchBatchWeightSummary()
    try {
      const {
        data: { batchPlant }
      } = await this.getStrainList(this.$route.params.id)
      this.batchStrains = batchPlant.map((plant) => ({ value: plant.plant_name, label: plant.plant_name }))
      // eslint-disable-next-line no-empty
    } catch (err) {}
    try {
      await this.getData()
      // eslint-disable-next-line no-empty
    } catch (err) {}
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#table-loading',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#table-loading > .con-vs-loading')
      }
    },
    processing() {
      if (this.processing) {
        this.$vs.loading({
          container: '#add-batch-weight-summary-button',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#add-batch-weight-summary-button > .con-vs-loading')
      }
    },
    isEditMode() {
      if (this.isEditMode) {
        this.errors.clear()
      }
    }
  },

  // filters
  filters: {
    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  }
}
</script>
